import React, { Component } from 'react';
class ProxyEnv extends Component {
 constructor(props) {
   super(props);
   this.state = {
	 buildEnvironment: props.initialSelectedOptions || [], // Equivalent to useState for buildEnvironment
	 options: [ // Example options
	   { id: 'TEST', label: 'TEST' },
	   { id: 'PILOT', label: 'PILOT' },
	   { id: 'PRODUCTION', label: 'PRODUCTION' },
	 ],
   };
   this.handleChange = this.handleChange.bind(this);
 }

 isValidated() {
	if(this.state.buildEnvironment === null || this.state.buildEnvironment.length === 0) {
			return false;
	}

	};

 componentDidMount() {

  const storeData = this.props.getStore().buildEnvironment;
	if(null !== storeData && storeData.length > 0){
	let previousState = storeData.split(",");
	this.setState({buildEnvironment:previousState});
 }

 }

 componentDidUpdate(prevProps, prevState) {

   if (prevState.buildEnvironment !== this.state.buildEnvironment) {
	  this.props.updateStore({buildEnvironment: this.state.buildEnvironment.join(",")});
	 if (this.props.onChange) {
	   this.props.onChange(this.state.buildEnvironment);
	 }
   }

 }

 componentWillUnmount() {

 }
 handleChange(event) {
   const { value, checked } = event.target;
   this.setState(prevState => {
	 let newSelectedOptions;
	 if (checked) {
	   newSelectedOptions = [...prevState.buildEnvironment, value];
	 } else {
	   newSelectedOptions = prevState.buildEnvironment.filter(
		 optionId => optionId !== value
	   );
	 }

	 return { buildEnvironment: newSelectedOptions };
   });
 }
 render() {
   const { options, buildEnvironment } = this.state;
   return (
		<div>
		<div className="container">
		<br/>
		<div className="row">
			<div className="col-md-25" style={{ paddingLeft: '15px'}}>
			<h4>Proxy Environment</h4>
			<p>Select in which environment (test/pilot/production) your service should be running.</p>
				{options.map(option => (
			<div key={option.id}>
			<input
						type="checkbox"
						id={option.id}
						value={option.id}
						checked={buildEnvironment.includes(option.id)}
						onChange={this.handleChange}
					/>
			 <label style={{ paddingLeft: '10px'}} htmlFor={option.id}><br></br>{option.label}</label>
			</div>
				))}
		</div>
		</div>
		</div>
		</div>
   );
 }
}
export default ProxyEnv;